import { api } from '../http';

export const fetchDispensationWatch = dispensationId =>
  api.get(`/dispensations/${dispensationId}/watch`);
export const updateDispensationWatch = dispensationId =>
  api.patch(`/dispensations/${dispensationId}/watch`);
